import React from 'react';

const chatChannelContextInitialState = {
  isReady: true,
  activeChannel: null,
  setActiveChannel: () => {},
  messages: [],
  visibleMessages: [],
  loadMoreMessages: () => {},
  isLoadingMessages: false,
  hasMoreMessages: true,
  unseenThreadCount: 0,
  unreadThreadRows: [],
  recentThreadRows: [],
  isUnreadTruncated: false,
  markThreadRead: () => {},
  markAllRead: () => {},
  isThreadInboxOpen: false,
  setIsThreadInboxOpen: () => {},
  threadNoticeRootId: null,
  setThreadNoticeRootId: () => {},
  quotedMessage: null,
  setQuotedMessage: () => {},
  sendMessage: () => {},
  scheduleMessage: () => {},
  updateScheduledMessage: () => {},
  deleteScheduledMessage: () => {},
  scheduledMessages: [],
  isUploading: false,
  uploadProgress: {},
  unreadCountDoc: {},
  scheduledCount: 0,
  coachTimezone: null,
  setScheduledCount: () => {},
  isVideoReady: false,
  setIsVideoReady: () => {},
  smartContextText: '',
  setSmartContextText: () => {},
  scheduleQueue: [],
  scheduledMessageIds: [],
  handleAddToScheduleQueue: () => {},
  handleQueueTextChange: () => {},
  setScheduleQueue: () => {},
};

const ChatChannelContext = React.createContext(chatChannelContextInitialState);

export default ChatChannelContext;
export {
  chatChannelContextInitialState,
};
